import { Location } from 'history';
import { parse, stringify } from 'querystring';

import { USWEST_DATASOURCES } from '../../constants/datasources';
import { CONFIG } from '../../meta/types/config';
import { Instance } from '../../meta/types/wms/Instance';
import { Layer } from '../../meta/types/wms/Layer';

export function injectParameters(urlTemplate: string, data: any, hasBody = true): string {
  let url = urlTemplate;

  data = { ...data };

  for (const tag of url.match(/:\w+/g) || []) {
    const urlTag = tag.slice(1);

    // PORT :8000/...
    if (!isNaN(parseInt(urlTag, 10))) {
      delete data[urlTag];
      continue;
    }
    let value = data[urlTag];
    if (value === undefined) {
      value = urlTag;
    }
    url = url.replace(tag, encodeURIComponent(value));
    delete data[urlTag];
  }

  if (!hasBody) {
    const qs = stringify(data);
    if (qs) {
      url += (url.indexOf('?') >= 0 ? '&' : '?') + qs;
    }
  }
  return url;
}

function injectQueryParams(urlTemplate: string, data: any): string {
  return injectParameters(urlTemplate, data, false);
}

function mapLayerForLayerMap(layer: Layer): string {
  const { type } = layer.datasourceDefaults;
  const mappedType = type === 'MODIS' ? 'Modis' : type === 'L8L1C' ? 'L8' : type;
  return `${layer.id},${mappedType}`;
}

export function generatePlaygroundLink(instance: Instance): string {
  const layers = instance.layers || [];
  const USWestOnly =
    layers.length > 0 &&
    layers.every(layer => USWEST_DATASOURCES.includes(layer.datasourceDefaults.type));

  let baseWmsUrl = USWestOnly
    ? CONFIG.usWestWmsServiceBasePath
    : CONFIG.wmsConfigurationServiceBasePath;

  baseWmsUrl = baseWmsUrl.replace('https://', '').split('/')[0].replace('test.hq', 'services');

  const layerMap = layers.map(mapLayerForLayerMap).join(';');
  const basePlaygroundUrl = injectQueryParams(
    `${CONFIG.playgroundAppBaseUrl}/sentinel-playground/`,
    {
      baseWmsUrl,
      instanceID: instance.id,
    },
  );

  return injectQueryParams(`${basePlaygroundUrl}&layerMap=${layerMap}`, {
    lat: 10,
    lng: 5,
    zoom: 9,
  });
}

export function parseIdFromUrl(path: string) {
  const split = path.split('/');
  return split[split.length - 1];
}

export const openExternalUrl = (path: string) => () => {
  window.open(path, '_blank');
};

export function parseQueryParams(location: Location | typeof window.location) {
  return parse(location.search.replace('?', ''));
}
